<div tabindex="-2" role="dialog" aria-labelledby="dialog-static-name">
  <div role="dialog" aria-labelledby="dialog-static-name">
    <ng-container>
      <app-loading-spinner *ngIf="loadSpinner"> </app-loading-spinner>
      <ng-container *ngTemplateOutlet="listLoadsFiles"> </ng-container>
    </ng-container>
  </div>
</div>

<ng-template #listLoadsFiles>
  <generic-table-avla
    *ngIf="!loadSpinner && loadFilesData"
    #infoLoadFilesTable
    [jsonData]="loadFilesData"
    [columns]="loadFileColumns"
    [serverPagination]="false"
    [showFilterByColumn]="false"
    [enableGeneralSearch]="true"
    [editableRow]="false"
    [deletableRow]="false"
    [showReloadButton]="false"
    [showSelectorRowsOnPage]="false"
    [textTableLoading]="'Cargando...'"
    [templateColumns]="{
      estado: filestatusTemplate,
      acciones: fileOptionsTemplate
    }">
  </generic-table-avla>
  <ng-template
    #fileOptionsTemplate
    let-item="item"
    let-col="col"
    let-cellValue="cellValue">
    <button
      type="button"
      title="Descargar"
      class="btn btn-info btn-xs"
      (click)="downloadFile(item.urlFile, item.name)">
      <i class="fa fa-download"></i>
    </button>
  </ng-template>
  <ng-template
    #filestatusTemplate
    let-item="item"
    let-col="col"
    let-cellValue="cellValue">
    <ng-container *ngIf="item.status == 'LOAD'">
      <label class="label label-success">{{ 'LOADED-FILE' | i18n }}</label>
    </ng-container>
    <ng-container *ngIf="item.status == 'NOT_LOAD'">
      <label class="label label-danger">{{ 'NOT-LOADED-FILE' | i18n }}</label>
    </ng-container>
  </ng-template>
</ng-template>
